enum DelegationListingDelegationType {
  MANUAL = "MANUAL",
  AUTO = "AUTO",
}

export default DelegationListingDelegationType;
